export const routes = {
  home: '/',
  products: '/products',
  woodEngraving: '/products/wood-engraving',
  ornaments: '/products/ornaments',
  tshirts: '/products/tshirts',
  search: '/search',
  about: '/about',
  howItWorks: '/how-it-works',
  contact: '/contact',
  faq: '/faq',
  privacy: '/privacy',
  terms: '/terms',
  login: '/login',
  register: '/register',
  verifyEmail: '/verify-email',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  logout: '/logout',
  unauthorized: '/unauthorized',
  dashboard: '/dashboard',
  checkout: '/checkout',
  orders: '/orders',
  account: '/account',
  accountProfile: '/account/profile',
  accountCommunication: '/account/communication',
  accountSecurity: '/account/security',
  accountConsents: '/account/consents',
  admin: '/admin',
  adminCatalog: '/admin/catalog',
  adminCategories: '/admin/catalog/categories',
  adminCategoryNew: '/admin/catalog/categories/new',
  adminProducts: '/admin/catalog/products',
  adminProductNew: '/admin/catalog/products/new',
  adminCatalogMedia: '/admin/catalog/media',
  workshop: '/workshop',
  notFound: '/not-found',
} as const;

export function productDetailRoute(categorySlug: string, productSlug: string) {
  return `${routes.products}/${categorySlug}/${productSlug}` as const;
}

export const adminCategoryRoute = (id: string) =>
  `${routes.adminCategories}/${encodeURIComponent(id)}`;
export const adminCategoryAuditRoute = (id: string) => `${adminCategoryRoute(id)}/audit`;
export const adminProductRoute = (id: string) =>
  `${routes.adminProducts}/${encodeURIComponent(id)}`;
export const adminProductAuditRoute = (id: string) => `${adminProductRoute(id)}/audit`;

type LoginRouteOptions = { redirect?: string | undefined; email?: string | undefined };
type EmailRouteOptions = { email?: string | undefined };
type ResetPasswordRouteOptions = { email?: string | undefined; code?: string | undefined };

function withSearchParams(path: string, values: Record<string, string | undefined>) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value) search.set(key, value);
  }
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}

export function buildLoginRoute(options: LoginRouteOptions = {}) {
  return withSearchParams(routes.login, options);
}

export function buildVerifyEmailRoute(options: EmailRouteOptions = {}) {
  return withSearchParams(routes.verifyEmail, options);
}

export function buildForgotPasswordRoute(options: EmailRouteOptions = {}) {
  return withSearchParams(routes.forgotPassword, options);
}

export function buildResetPasswordRoute(options: ResetPasswordRouteOptions = {}) {
  return withSearchParams(routes.resetPassword, options);
}
